import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DTEConfigurationForm } from '../../../types/hacienda/DTEConfigurationTypes';
import { DropdownDTO } from '../../../types/common/DropdownDTO';

interface DTEConfigurationState {
    form: DTEConfigurationForm;
    isLoading: boolean;
    isSubmitting: boolean;
    error: string | null;
    environments: DropdownDTO[];      // ✅ antes era ambientes
    currencies: DropdownDTO[];        // ✅ antes era monedas
    billingModels: DropdownDTO[];     // ✅ soporte para nuevos modelos de facturación
    transmissionTypes: DropdownDTO[]; // ✅ soporte para nuevos tipos de transmisión
}

const initialState: DTEConfigurationState = {
    form: {
        id: null,
        environmentId: null,
        environmentName: '',
        currencyId: null,
        currencyName: '',
        billingModelId: null, // ✅ new field
        billingModelName: '',
        transmissionTypeId: null, // ✅ new field
        transmissionTypeName: '',
        active: true,
        versionInvalidation: 0
    },
    isLoading: false,
    isSubmitting: false,
    error: null,
    environments: [],               // ✅ renamed from ambientes
    currencies: [],                 // ✅ renamed from monedas
    billingModels: [],              // ✅ new list
    transmissionTypes: [],          // ✅ new list
};


const dteConfigurationSlice = createSlice({
    name: 'haciendaConfig',
    initialState,
    reducers: {
        setLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },
        setSubmitting(state, action: PayloadAction<boolean>) {
            state.isSubmitting = action.payload;
        },
        setError(state, action: PayloadAction<string | null>) {
            state.error = action.payload;
        },
        setDTEConfiguration(state, action: PayloadAction<DTEConfigurationForm>) {
            state.form = action.payload;
            state.error = null;
        },
        updateDTEConfigurationField(
            state,
            action: PayloadAction<{ field: keyof DTEConfigurationForm; value: any }>
        ) {
            const { field, value } = action.payload;
            state.form = {
                ...state.form,
                [field]: value,
            };
        },
        resetDTEConfiguration(state) {
            state.form = initialState.form;
            state.isSubmitting = false;
            state.error = null;
        },
        // ✅ Save environment list
        setEnvironments(state, action: PayloadAction<DropdownDTO[]>) {
            state.environments = action.payload;
        },
        // ✅ Save currency list
        setCurrencies(state, action: PayloadAction<DropdownDTO[]>) {
            state.currencies = action.payload;
        },
        // ✅ Save billing model list
        setBillingModels(state, action: PayloadAction<DropdownDTO[]>) {
            state.billingModels = action.payload;
        },
        // ✅ Save transmission type list
        setTransmissionTypes(state, action: PayloadAction<DropdownDTO[]>) {
            state.transmissionTypes = action.payload;
        },
    },
});

export const {
    setLoading,
    setSubmitting,
    setError,
    setDTEConfiguration,          // antes setHaciendaConfig
    updateDTEConfigurationField,  // antes updateHaciendaField
    resetDTEConfiguration,        // antes resetHaciendaConfig
    setEnvironments,              // antes setAmbientes
    setCurrencies,                // antes setMonedas
    setBillingModels,
    setTransmissionTypes,
} = dteConfigurationSlice.actions;


export default dteConfigurationSlice.reducer;
